module.exports = __webpack_public_path__ + "img/EPriestPtah64_ua.0d2a57bd.webp";